export const services = [
  {
    id: 1,
    title: "Pool Leak Detection in Las Vegas — No Draining Required",
    description: "We find pool leaks fast using sonar, dye, and pressure testing — without draining your pool. Save water, save money. Call now for same-day service.",
    icon: "ri-water-flash-line"
  },
  {
    id: 2,
    title: "Water Leak Detection in Las Vegas — Fast & Accurate",
    description: "Hidden leaks found without guesswork or unnecessary damage. We use professional equipment to pinpoint the exact location — fast. Free estimate included.",
    icon: "ri-drop-line"
  },
  {
    id: 3,
    title: "Home Repiping in Las Vegas — Restore Pressure & Safety",
    description: "Old or corroded pipes causing low pressure or leaks? We replace them with durable PEX or copper — fully licensed, flat-rate pricing, same-day service available.",
    icon: "ri-tools-line"
  },
  {
    id: 4,
    title: "Mainline Replacement in Las Vegas — Fast & Reliable",
    description: "Water or sewer line failing? We diagnose the problem fast using video inspection and replace mainlines with lasting, professional results. Call now for a free estimate.",
    icon: "ri-settings-3-line"
  },
  {
    id: 5,
    title: "Slab Leak Repair in Las Vegas — Fast, Certified Fix",
    description: "Slab leaks cause serious structural damage if ignored. We locate and fix slab leaks the same day — certified specialists, no unnecessary demolition.",
    icon: "ri-hammer-line"
  },
  {
    id: 6,
    title: "24/7 Emergency Plumbing in Las Vegas — We Answer Every Call",
    description: "Burst pipe? Flooding? We respond immediately — 24 hours a day, 7 days a week. Call and speak directly to a certified plumber. No call centers, no wait.",
    icon: "ri-alarm-warning-line"
  },
  {
    id: 7,
    title: "Water Heater Installation in Las Vegas — Same-Day Service",
    description: "No hot water? We install tankless and traditional water heaters with same-day service and flat-rate pricing. Licensed, insured, and highly rated.",
    icon: "ri-temp-hot-line"
  },
  {
    id: 8,
    title: "Water Filtration & Softener in Las Vegas — Clean Water Guaranteed",
    description: "Protect your family with a whole-house water filtration or softener system. We install, test, and guarantee the results. Free estimate — call now.",
    icon: "ri-water-percent-line"
  },
  {
    id: 9,
    title: "Garbage Disposal Repair in Las Vegas — Fast & Reliable",
    description: "Garbage disposal not working? We diagnose and fix all makes and models — fast, affordable, and backed by flat-rate pricing. Same-day repairs available.",
    icon: "ri-recycle-line"
  },
  {
    id: 10,
    title: "Water Damage Restoration in Las Vegas — Fast Response",
    description: "Water damage spreads fast. We respond quickly to stop further damage, dry out the area, and restore your property. Call now before it gets worse.",
    icon: "ri-building-line"
  },
  {
    id: 11,
    title: "Sewer Line Repair in Las Vegas — Expert Diagnosis & Repair",
    description: "Sewer line backing up or broken? We use video inspection to pinpoint the issue and repair it right the first time. Fast, accurate, and certified. Call for a free estimate.",
    icon: "ri-tools-fill"
  },
  {
    id: 12,
    title: "Drain Cleaning in Las Vegas — Clear Clogs Fast",
    description: "Slow or clogged drains? We clear blockages fast and restore proper flow using professional snake and hydro-jet equipment. Same-day service available.",
    icon: "ri-filter-line"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Speak Directly to a Certified Plumber",
    description: "When you call us, you speak directly to an experienced plumber and certified leak detection specialist — not a receptionist or call center.",
    icon: "ri-customer-service-2-line"
  },
  {
    id: 2,
    title: "Flat-Rate Pricing — No Hourly Billing",
    description: "No hourly billing. No inflated invoices. Just honest, flat-rate pricing and expert workmanship on every job we do.",
    icon: "ri-price-tag-3-line"
  },
  {
    id: 3,
    title: "Certified Leak Detection Specialists",
    description: "We use professional leak detection equipment and real field experience to pinpoint problems accurately without guesswork or unnecessary damage.",
    icon: "ri-shield-check-line"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria G.",
    rating: 5,
    text: "Leak Detectives found a slab leak that two other companies missed. They were professional, honest, and fixed it the same day. I can't recommend them enough!",
    date: "1 week ago"
  },
  {
    id: 2,
    name: "James R.",
    rating: 5,
    text: "Called them for an emergency at 11pm and they actually answered — a real plumber, not a call center. Fixed our burst pipe quickly and the price was fair. Outstanding service.",
    date: "2 weeks ago"
  },
  {
    id: 3,
    name: "Sandra T.",
    rating: 5,
    text: "They detected a pool leak that was costing me hundreds in water bills. Used sonar and dye testing, found it fast, fixed it without draining the pool. Incredible work!",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Carlos M.",
    rating: 5,
    text: "Had my whole house repiped by Leak Detectives. The crew was clean, efficient, and explained everything clearly. Water pressure is amazing now. Worth every penny.",
    date: "1 month ago"
  },
  {
    id: 5,
    name: "Patricia L.",
    rating: 5,
    text: "Flat-rate pricing with no surprises — exactly what they promised. The technician was knowledgeable and got the job done right the first time. Will use again!",
    date: "1 month ago"
  },
  {
    id: 6,
    name: "Kevin D.",
    rating: 5,
    text: "Best plumbing company in Las Vegas. They installed my water heater and a whole-house filtration system. Professional, on time, and very reasonably priced.",
    date: "6 weeks ago"
  }
];

export const serviceAreas = [
  "Las Vegas", "Henderson", "North Las Vegas", "Summerlin", "Paradise",
  "Spring Valley", "Enterprise", "Sunrise Manor", "Whitney", "Winchester",
  "Boulder City", "Clark County", "Mesquite", "Pahrump", "Laughlin"
];
